export const environment = {
  production: false,
  masterApiURL: "https://stage-master-backend.epravaha.com/",
    ApiURL: "https://dev-nhrdf-backend.supplyvalid.com/api/",
    ApiURLW: "https://stage-backend-2025.epravaha.com/"
}